import { BaseBus } from "./BaseBus";

export class WipReportData extends BaseBus {
    constructor(data: WipReportData = null) {
        super(data);
    }
    directCustId;
    directCustOicId;
    directCustName;
    locationId;
    locationName;
    state;
    endUseCustId;
    endUseCustOicId;
    accountClassId;
    accountClassName;
    contAccountClassId;
    contAccountClassName;
    contDivisionId;
    contDivisionName;
    contDivisionSageId;
    JobNbr;
    jobId;
    pMId;
    pMEmpNo;
    pMName;
    pMEmpID;
    contPMId;
    contPMEmpNo;
    contPMName;
    contPMEmpId;
    contractNbr;
    contractId;
    contDispatchStatusId;
    contDispatchStatusName;
    dispatchStatusId;
    dispatchStatusName;
    tAndM;
    tAndMProfitPerc;
    isNewConstruction;
    contractDate;
    projectedEndDate;
    contractCloseDate;
    get hasEstimatedFields() {
        if (this.estimatedContractMaterialCosts && this.estimatedContractLaborCosts && this.estimatedContractOtherCosts && this.estimatedContractPendingCRCosts && this.pmEstimateAdjustments && this.estimatedContractMaterialCosts > 0 && this.estimatedContractLaborCosts > 0 && this.estimatedContractOtherCosts > 0 && this.pmEstimateAdjustments > 0) {
            return true;
        }
        else {
            return false;
        }
    }
    get percComplete() {
        //if (this.hasEstimatedFields) {
        //    return this.totalCurrentCosts / (this.totalEstimatedContractCosts)
        //} else { return 0 }
        if (!this.totalEstimatedContractCosts || (this.totalEstimatedContractCosts && this.totalEstimatedContractCosts == 0)) {
            return 0;
        }
        else {
            return ((this.totalCurrentCosts / (this.totalEstimatedContractCosts)) < 1 ? (this.totalCurrentCosts / (this.totalEstimatedContractCosts)) : 1);
        }
    };
    get percCompleteScaled() { return this.percComplete * this.scalingFactor };
    contractAmount;
    get totalEstimatedContractCosts() { return (this.estimatedContractMaterialCosts + this.estimatedContractLaborCosts + this.estimatedContractOtherCosts + this.estimatedContractPendingCRCosts + this.pmEstimateAdjustments) };
    estimatedContractMaterialCosts;
    estimatedContractLaborCosts;
    estimatedContractOtherCosts;
    estimatedContractPendingCRCosts;
    pmEstimateAdjustments;
    contractAdjustments;
    currentCostAdjustments;
    btdAdjustments;
    lastSixZeroSixAdjustment;
    get projectedGrossProfit() { return (this.contractAmount - (this.totalEstimatedContractCosts)) };
    get totGrossProfitPerc() {
        if (!this.contractAmount || (this.contractAmount && this.contractAmount == 0)) {
            return 0;
        } else {
            return (this.contractAmount - (this.totalEstimatedContractCosts)) / this.contractAmount;
        }
    };
    committedCosts;
    get jobsWCommittedCostsGTEstimatedCostsLTD() { return (this.totalEstimatedContractCosts) - this.committedCosts };
    bidHrs;
    actHrs;
    get percLaborhoursTD() {
        if (this.bidHrs && this.bidHrs > 0) {
            return this.actHrs / this.bidHrs
        } else { return 0 }
    };
    get contractRevenue() {
        //if (this.hasEstimatedFields) {
        //    return this.contractAmount * (this.totalCurrentCosts / (this.totalEstimatedContractCosts))
        //} else { return 0 }
        if ((this.percComplete) <= 1) {
            return this.contractAmount * (this.percComplete);
        } else {
            //return 1;
            return this.contractAmount;
        }
    };
    get contractRevenueScaled() { return this.contractRevenue * this.scalingFactor };
    get totalCurrentCosts() { return this.totalCurrentMaterialCosts + this.totalCurrentLaborCosts + this.totalCurrentOtherCosts };
    totalCurrentMaterialCosts;
    totalCurrentLaborCosts;
    totalCurrentOtherCosts;
    get currentGrossProfit() {
        //if (this.hasEstimatedFields) {
        //    return (this.contractRevenue) - (this.totalCurrentCosts)
        //} else { return 0 }
        return (this.contractRevenue) - (this.totalCurrentCosts);
    };
    billedToDate;
    get billedToDateScaled() { return this.billedToDate * this.scalingFactor };
    get billingsInExcessCostsEstEarningsCostEstEarningsExcessBillings() {
        //if (this.hasEstimatedFields) {
        //    return (this.billedToDate) - (this.contractRevenue)
        //} else { return 0 }
        return (this.billedToDate) - (this.contractRevenue);
    };
    get backlog() {
        //if (this.hasEstimatedFields) {
        //    return this.contractAmount - (this.contractRevenue)
        //} else { return 0 }
        return this.contractAmount - (this.contractRevenue);
    };
    get totalCostsToComplete() { return (this.totalEstimatedContractCosts) - (this.totalCurrentCosts) };
    get totalMaterialCostsToComplete() { return this.estimatedContractMaterialCosts - this.totalCurrentMaterialCosts};
    get totalLaborCostsToComplete() { return this.estimatedContractLaborCosts - this.totalCurrentLaborCosts};
    get totalOtherCostsToComplete() { return this.estimatedContractOtherCosts + this.pmEstimateAdjustments - this.totalCurrentOtherCosts };
    get totalAdjustmentsToBeComplete() { return this.pmEstimateAdjustments };
    get grossProfit() {
        //if (this.hasEstimatedFields) {
        //    return (this.backlog) - (this.totalCostsToComplete)
        //} else { return 0 }
        return (this.backlog) - (this.totalCostsToComplete);
    };
    get grossProfitPerc() {
        //if (this.contractAmount && this.contractAmount > 0 && this.hasEstimatedFields) {
        //    return (this.grossProfit / this.backlog)
        //} else { return 0 }
        if (!this.backlog || (this.backlog && this.backlog == 0)) {
            return 0;
        } else {
            return (this.grossProfit / this.backlog);
        }
    };
    get amountNotYetBilled() {
        //if (this.hasEstimatedFields) {
        //    return ((this.contractAmount) - (this.billedToDate))
        //} else { return 0 }
        return ((this.contractAmount) - (this.billedToDate));
    };
    //get paidToDate() { return };
    divisionId;
    divisionName;
    divisionSageId;
    glCode;
    scalingFactor = 1;
}
